import { Box } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import { useContext } from 'react';
import FiltersAndSegmentsContext from '../FiltersAndSegmentsContext';
import CheckboxCell from './TableCells/CheckboxCell';

export function ExpandedTable({ companyId }: any) {
  const { ideasFiltersConfig, perspectiveConfigurations } = useContext(FiltersAndSegmentsContext)

  // Get the appropriate data based on companyId
  let childFiltersArray: any[] = [];
  const ideaFiltersAttributesObj = ideasFiltersConfig?.idea || {};
  const evidenceFiltersAttributes = ideasFiltersConfig?.evidence || {};
  if (companyId === 1) {
    // Idea Attributes - get all idea filters directly
    
  
    childFiltersArray = Object.values(ideaFiltersAttributesObj)
      .map((filter: any) => ({
        name: filter.name || 'Unknown',
        label: filter.label || 'Unknown',
      }));
  } else {
    // Evidence Attributes - get childFilters from evidence filters
    // Get the filtered evidence filters (only those with childFilters)
    const filteredEvidenceFilters = Object.fromEntries(
      Object.entries(evidenceFiltersAttributes).filter(([key, filterData]: [string, any]) => 
        filterData?.childFilters
      )
    );
    
    // Get the specific evidence filter by index (companyId - 2 because idea is 1, so evidence starts at 2)
    const evidenceFilterKeys = Object.keys(filteredEvidenceFilters);
    const evidenceFilterIndex = companyId - 2; // Adjust for the offset
    const evidenceFilterKey = evidenceFilterKeys[evidenceFilterIndex];
    const evidenceFilter = evidenceFilterKey ? filteredEvidenceFilters[evidenceFilterKey] : null;
  
    if (evidenceFilter && typeof evidenceFilter === 'object' && 'childFilters' in evidenceFilter) {
      childFiltersArray = Object.values((evidenceFilter as any).childFilters)
        .map((childFilter: any) => ({
          name: childFilter.name || 'Unknown',
          label: childFilter.label || 'Unknown',
        }));
    }
  }

  return (
    <Box className="expanded-row" p="md">
      <DataTable
        noHeader
        withColumnBorders
        highlightOnHover
        columns={[
          {
            accessor: 'name',
            title: 'FILTER NAME',
            noWrap: true,
            width: 250,
            render: ({ name, label }: {  name: string, label: string }) => (
              <Box component="span" ml={20}>
                <span className="filter-name-cell">{label}</span>
              </Box>
            ),
          },
          {
            accessor: 'ideas-list-idea-page',
            title: 'IDEAS LIST & IDEA PAGE',
            noWrap: true,
            width: 220,
            render: ({ name }: { name: string }) => {
              if (companyId === 1){
                return (
                  <CheckboxCell id={companyId} name={name} page='ideas-idea' isChecked={
                    Object.values(ideaFiltersAttributesObj).some((filter: any) => 
                      filter.name === name && (filter.enabled === true || filter.enabled === undefined)
                    )
                  }/>
                );
              }

              else{
                // Get the specific evidence filter for this companyId (same logic as above)
                const filteredEvidenceFilters = Object.fromEntries(
                  Object.entries(evidenceFiltersAttributes).filter(([key, filterData]: [string, any]) => 
                    filterData?.childFilters
                  )
                );
                
                const evidenceFilterKeys = Object.keys(filteredEvidenceFilters);
                const evidenceFilterIndex = companyId - 2;
                const evidenceFilterKey = evidenceFilterKeys[evidenceFilterIndex];
                const evidenceFilter = evidenceFilterKey ? filteredEvidenceFilters[evidenceFilterKey] : null;

                if (evidenceFilter && typeof evidenceFilter === 'object' && 'childFilters' in evidenceFilter) {
                  const childFilters = Object.values((evidenceFilter as any).childFilters);
                  const childFilter = childFilters.find((filter: any) => filter.name === name);
                  
                  return (
                    <CheckboxCell id={companyId} name={name} page='ideas-idea' isChecked={
                      Boolean(childFilter && ((childFilter as any).enabled === true || (childFilter as any).enabled === undefined))
                    }/>
                  );
                }

                return (
                  <CheckboxCell id={companyId} name={name} page='ideas-idea' isChecked={false}/>
                );
              }
              
            },
          },
          {
            accessor: 'perspective',
            title: 'PERSPECTIVE',
            width: 200,
            render: ({ name }: { name: string }) => (
              <CheckboxCell id={companyId} name={name} page='perspective' isChecked={
                perspectiveConfigurations.some((config: any) => config.key === name)
              }/>
            ),
          },
          {
            accessor: 'customer360',
            title: 'C360 PAGE',
            width: 200,
            render: ({ name }: { name: string }) => {
              // Get the specific evidence filter for this companyId (same logic as above)
              const filteredEvidenceFilters = Object.fromEntries(
                Object.entries(evidenceFiltersAttributes).filter(([key, filterData]: [string, any]) => 
                  filterData?.childFilters
                )
              );
              
              const evidenceFilterKeys = Object.keys(filteredEvidenceFilters);
              const evidenceFilterIndex = companyId - 2;
              const evidenceFilterKey = evidenceFilterKeys[evidenceFilterIndex];
              const evidenceFilter = evidenceFilterKey ? filteredEvidenceFilters[evidenceFilterKey] : null;

              if (evidenceFilter && typeof evidenceFilter === 'object' && 'childFilters' in evidenceFilter) {
                const childFilters = Object.values((evidenceFilter as any).childFilters);
                const childFilter = childFilters.find((filter: any) => filter.name === name);
                
                return (
                  <CheckboxCell 
                    id={companyId} 
                    name={name} 
                    page='customer360' 
                    isChecked={
                      Boolean(childFilter && (childFilter as any).showIn360)
                    }
                  />
                );
              }

              return (
                <CheckboxCell 
                  id={companyId} 
                  name={name} 
                  page='customer360' 
                  isChecked={false}
                />
              );
            },
          },
        ]}
        records={childFiltersArray}
      />
    </Box>
  );
} 